"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto = require("crypto");
function md5(data) {
    return crypto.createHash("md5").update(data).digest("hex");
}
exports.default = md5;
//# sourceMappingURL=md5.js.map